/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementCategoryRef,
  AgreementCategoryRefOptional,
  AgreementCategoryRefMetaI,
  AgreementCategoryRefTrackedI,
} from "./agreement-category-ref";
import {
  AgreementCategoryRefTracked,
  AgreementCategoryRefMeta,
} from "./agreement-category-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CategoryRef,
  CategoryRefOptional,
  CategoryRefMetaI,
  CategoryRefTrackedI,
} from "./category-ref";
import { CategoryRefTracked, CategoryRefMeta } from "./category-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";

/**
 *
 * @export
 * @interface AgreementCategoryFull
 */
export interface AgreementCategoryFullOptional extends AgreementCategoryRefOptional {
  /**
   *
   * @type {boolean}
   * @memberof AgreementCategoryFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementCategoryFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementCategoryFull
   */
  assignId?: number;
  /**
   *
   * @type {CategoryRef}
   * @memberof AgreementCategoryFull
   */
  categoryId?: CategoryRefOptional;
}

export interface AgreementCategoryFull
  extends AgreementCategoryFullOptional, AgreementCategoryRef, Deletable {
  /**
   *
   * @type {boolean}
   * @memberof AgreementCategoryFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementCategoryFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementCategoryFull
   */
  assignId: number;
  /**
   *
   * @type {CategoryRef}
   * @memberof AgreementCategoryFull
   */
  categoryId: CategoryRef;
}

export interface AgreementCategoryFullTrackedI extends AgreementCategoryRefOptional {
  /**
   *
   * @type {boolean}
   * @memberof AgreementCategoryFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof AgreementCategoryFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof AgreementCategoryFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {CategoryRef}
   * @memberof AgreementCategoryFull
   */
  categoryId?: CategoryRefTrackedI;
  categoryIdIsSet: boolean;
}

transformDatesMap.set(
  "AgreementCategoryFull",
  function (model: AgreementCategoryFull) {
    const transformDatescategoryId = transformDatesMap.get("CategoryRef");
    if (transformDatescategoryId && model.categoryId) {
      transformDatescategoryId(model.categoryId);
    }
  },
);

export type AgreementCategoryFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  categoryId: PropertyMeta<CategoryRefMetaI>;
}>;

export var AgreementCategoryFullMeta: AgreementCategoryFullMetaI =
  {} as AgreementCategoryFullMetaI;
AgreementCategoryFullMeta = typeMeta("AgreementCategoryFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  categoryId: propertyMeta("categoryId", false, true, false, CategoryRefMeta),
});

const metaI = AgreementCategoryFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([AgreementCategoryRefMeta]);
  metaI.assignId.inheritedFrom = AgreementCategoryRefMeta.assignId;
});

export class AgreementCategoryFullTracked
  extends AgreementCategoryRefTracked
  implements AgreementCategoryFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  categoryId__I?: CategoryRefTracked = undefined;
  categoryIdIsSet: boolean = false;
  set categoryId(v: undefined | CategoryRefTracked) {
    if (v !== undefined) {
      this.categoryId__I = v;
      this.categoryIdIsSet = true;
    } else {
      this.categoryId__I = v || undefined;
      this.categoryIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get categoryId() {
    return this.categoryId__I;
  }
  constructor(config?: AgreementCategoryFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.categoryId?.setIds();
  }
  assignFrom(
    config: AgreementCategoryFullOptional,
    options?: AssignOptions,
  ): AgreementCategoryFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.categoryId &&
      this.categoryIdApplyFilter(optionsRequired.filter)
    ) {
      this.categoryId = new CategoryRefTracked(config.categoryId, options);
      if (optionsRequired.unassign) this.categoryIdIsSet = false;
      else this.categoryIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): AgreementCategoryFullTrackedI {
    const cloned = {} as AgreementCategoryFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.categoryIdIsSetDeep() &&
      this.categoryIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoryIdIsSet = true;
      cloned.categoryId = this.categoryId?.removeUnset(filter);
    } else {
      //cloned.categoryIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): AgreementCategoryFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.categoryIdApplyFilter(filter)) this.categoryIdIsSet = false;
    this.categoryId?.unassignAll(filter);

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementCategoryFullMeta.isDeleted,
      AgreementCategoryFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementCategoryFullMeta.isNew,
      AgreementCategoryFullMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementCategoryFullMeta.assignId,
      AgreementCategoryFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  categoryIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      AgreementCategoryFullMeta.categoryId,
      AgreementCategoryFullMeta,
      this.categoryId,
      this,
    );
  }
  categoryIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoryIdIsSet && this.categoryIdApplyFilter(filter)) return true;
    return this.categoryId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.categoryIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
